module.controller('cardholderAgreementCtrl', ['$scope', '$state', '$sce', '$stateParams', 'brandService', function ($scope, $state, $sce, $stateParams, brandService) {
    var vm = this;

    $scope.cardholderAgreementDocument = false;
    $scope.nextClicked = false;
    $scope.cardholderAgreementErrorMessage = 'Please check this box if you agree to the Cardholder Agreement. You must agree to the Cardholder Agreement to continue.';

    var brand = brandService.getBrand($stateParams.brand);

    vm.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
    };

    function goTo(nextStep) {
        $scope.nextClicked = true;
        if($scope.cardholderAgreementDocument) {
            $state.go(nextStep, {joinType: $scope.joinType});
        }
    }

    vm.goTo = goTo;
    vm.pdfGDSrc = brand.programLegal.agreement;

    vm.openModal = function(){
        vm.showModal = true;
    };

    vm.closeModal = function(){
        vm.showModal = false;
    };

    vm.goToLogin = function(){
        $state.go('root.login');
    };

}]);
